import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

import { getContextGraphVisualization } from '@/services/context-graphs/get-context-graph-visualization';
import { useOrgStore } from '@/stores/org-store';

export const contextGraphVisualizationKey = (
  orgId: string | null,
  graphId: string | null,
  limit = 250,
) => ['context-graph-visualization', orgId, graphId, limit];

export const useContextGraphVisualization = (
  graphId: string | null,
  limit = 250,
) => {
  const orgId = useOrgStore((state) => state.currentOrg?.orgid ?? null);

  return useQuery({
    queryKey: contextGraphVisualizationKey(orgId, graphId, limit),
    queryFn: async () => {
      try {
        return await getContextGraphVisualization(graphId as string, limit);
      } catch (error) {
        Sentry.captureException(error, {
          extra: { context: 'context-graph-visualization', orgId, graphId },
        });
        throw error;
      }
    },
    enabled: Boolean(orgId && graphId),
    staleTime: 30_000,
  });
};
